import { PROVIDER_CATEGORY_PREFIX } from 'root/util/constants';

export function filterHotGameListByMenuSettings(gameList, menuSlice, language, viewType, supportedProviderList, isFilterHotGames = true) {
    if (!isFilterHotGames) return gameList;

    return filterGamesByMenuSettings(gameList, menuSlice, language, viewType, supportedProviderList);
}

export function filterGamesByMenuSettings(gameList, menuSlice, language, viewType, supportedProviderList) {
    const subCategoryMenus = menuSlice?.processedBaseMenuSettings?.subCategoryMenus || {};
    const isSupportedProvider = (game) => {
        if (!supportedProviderList) return true;
        const providerIdentifiers = [game.provider, game.providerName, game.providerCode].filter(Boolean).map((p) => String(p).toLowerCase());

        return [...supportedProviderList].some((p) => providerIdentifiers.includes(String(p).toLowerCase()));
    };
    const findCategoryByProvider = (providerKey) => {
        const key = String(providerKey || '').toLowerCase();
        for (const [categoryKey, providers] of Object.entries(subCategoryMenus)) {
            const matched = (providers || []).some((p) => String(p?.provider || '').toLowerCase() === key || String(p?.name || '').toLowerCase() === key);
            if (matched) return categoryKey;
        }

        return null;
    };
    const resolveGameCategory = (game) => {
        const aliasKey = PROVIDER_CATEGORY_PREFIX[game.category];
        if (aliasKey) return aliasKey;
        if (game.category && subCategoryMenus[game.category]) return game.category;

        return findCategoryByProvider(game.providerCode || game.provider || game.providerName);
    };
    const isProviderEnabled = (categoryKey, providerKey) => {
        const providers = subCategoryMenus[categoryKey] || [];
        const key = String(providerKey || '').toLowerCase();

        return providers.some((p) => String(p?.provider || '').toLowerCase() === key || String(p?.name || '').toLowerCase() === key);
    };

    return (gameList || []).filter((game) => {
        if (!isSupportedProvider(game)) return false;
        const categoryKey = resolveGameCategory(game);
        if (!categoryKey || !subCategoryMenus[categoryKey]) return true;
        if (!isProviderEnabled(categoryKey, game.provider)) return false;
        if (game.fallbackGameForProvider && isProviderEnabled(categoryKey, game.fallbackGameForProvider)) return false;

        return true;
    });
}
